import React, {Component} from 'react';
import PageAuthorize from '../../../../security/PageAuthorize';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import EditSectionInput from '../../../../presentation/EditSectionInput';
import EditSectionDropdown from '../../../../presentation/EditSectionDropdown';
import Overlay from '../../../../presentation/ListExport';
import ListExport from '../../../../presentation/ListExport';
import ListExportDialog from '../../../../presentation/ListExportDialog';
import EtelAPI from '../../../../api/EtelAPI';
import Alerts from '../../../../prototypes/Alerts';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import Select from 'react-select';
import MonthlyStatsTile from './MonthlyStatsTile';
import ReactToolTip from 'react-tooltip';

import RefreshTimer from '../../../../presentation/RefreshTimer';
import Loadable from 'react-loadable';

import * as wjcCore from 'wijmo/wijmo';
import * as wjcGrid from 'wijmo/wijmo.grid';
import * as wjcGridXlsx from 'wijmo/wijmo.grid.xlsx';
import * as wjcXlsx from 'wijmo/wijmo.xlsx';
import * as JSZip from 'jszip';
wjcXlsx.useJSZip( JSZip );

wjcCore.setLicenseKey(
  'stage.etelconnections.com|172.16.0.116|dev.etelconnections.com|172.16.2.189|stage.eteconnections.com|172.16.1.15|www.etelconnections.com|172.16.0.112|lv.etelconnections.com|etelconnections.com|www.dev.etelconnections.com|172.16.1.22,854482378799655#B032Sbj9ycu3Wa4NWZu96bjxWZ4VmLldWY4NnI0IyctRkIsIybjVGblRVLFJiOiEmTDJCLiUTN6kTO7gzNzIDO4QTN8IiOiQWSiwSfdtlOicGbmJCLiIjdyIDMyIiOiIXZ6JCLlNHbhZmOiI7ckJye0ICbuFkI1pjIEJCLi4TPBh7RwYjWClUQRFnby9UMrYUcIJEZa5EevlTSzJHepVjdqxEZsl7QxhUS4t6UyFEdPNGbClWMQJHc7Z4Kv2EcG5kQwVzdMd4dIpHMrwWcz8ESONUW4wUQ7tCSBhmMIhzcykGTMpmTlNXMvpXRrd5Qo3ES7NUcPtSM9YHMMBVRJ36MtxUTxx6cBdlM64mUIZDMOdGWYhGZC3EcHdkRSZjZFBFUZ5GZX9ET8tSTMNVe5R7dzhlaYFUc5YVOadUe6ZjZWVDULt4RNBndYJ7U4NTbwckRItUUsF7c42Wc94WVEh7Y4JzRQRmMnJ5QrAnaThWdygVSqdkZaBFRrlHVP3UcrYENzRTOVR5bRJXQ6xka8ZnTqdlcitEcxtWZzhFSqZXaZJkeG3yKFZkSCpkR6QnexYjb43SWH9UbChXRykGTkxETn5UVrlzavIlR0lFNuNkbtZEdIJDSiojITJCLikTO6czN6IUNiojIIJCLwEjM6gDM4gTO0IicfJye35XX3JSSwIjUiojIDJCLi86bpNnblRHeFBCI4VWZoNFelxmRg2Wbql6ViojIOJyes4nI5kkTRJiOiMkIsIibvl6cuVGd8VEIgIXZ7VWaWRncvBXZSBybtpWaXJiOi8kI1xSfis4N8gkI0IyQiwiIu3Waz9WZ4hXRgAydvJVa4xWdNBybtpWaXJiOi8kI1xSfiQjR6QkI0IyQiwiIu3Waz9WZ4hXRgACUBx4TgAybtpWaXJiOi8kI1xSfiMzQwIkI0IyQiwiIlJ7bDBybtpWaXJiOi8kI1xSfiUFO7EkI0IyQiwiIu3Waz9WZ4hXRgACdyFGaDxWYpNmbh9WaGBybtpWaXJiOi8kI1tlOiQmcQJCLiAzMwEDOwAyNxgDMzIDMyIiOiQncDJCLiIjMuEjL6EjLycTMs46bj9ycu3Wa4NWZu96bjxWZ4VmL6VGZuc7d7xSbvNmLz96bpR7Yl9mbvNGblRXZs46bj9ycu3Wa4NWZu96bjxWZ4VmL6xGLyETMuAjL6EjLycTMs46bj9ycu3Wa4NWZu96bjxWZ4VmL7d7dsUTMuEjL6EjLycTMs46bj9ycu3Wa4NWZu96bjVGdl9SZnFGdzxSO8EjLy8iNx8iM7EDLt36YuMnbvlGdjVmbu36YsVGdl9idlRGL6ETMuAjL6EjLtcYM'
);


const LoadableDashboardGaugeChart = Loadable( {
  loader: () => import( /* webpackChunkName: "DashboardGaugeChartChunk" */ './DashboardGaugeChart' ),
  loading: () => <div> LOADING </div>,
} );

const LoadableDashboardGraph = Loadable( {
  loader: () => import( /* webpackChunkName: "DashboardGraphChunk" */ './DashboardGraph' ),
  loading: () => <div> LOADING </div>,
} );

const LoadableDashboardPieChart = Loadable( {
  loader: () => import( /* webpackChunkName: "DashboardPieChartChunk" */ './DashboardPieChart' ),
  loading: () => <div> LOADING </div>,
} );

const LoadableDashboardGrid = Loadable( {
  loader: () => import( /* webpackChunkName: "DashboardGridChunk" */ './DashboardGrid' ),
  loading: () => <div> LOADING </div>,
} );


class WholesaleDashboard extends Component {
  constructor( props ) {
    super( props );

    // Wijmo grid reference id
    this.wijmoGrid = 'wijmoGrid';
    this.monthlyStatsSection = 'monthlyStatsSection'; // Is this used anywhere?

    this.statsoptions = [
      {id: 0, text: 'This Month' },
      {id: 1, text: 'Last Month' },
    ];

    this.griddateoptions = [
      { id: 0, text: 'Today', value: 'today' },
      { id: 1, text: 'Yesterday', value: 'yesterday' },
      { id: 2, text: 'This Week', value: 'thisweek' },
      { id: 3, text: 'Last Week', value: 'lastweek' },
      { id: 4, text: 'This Month', value: 'thismonth' },
      { id: 5, text: 'Last Month', value: 'lastmonth' }
    ];

    this.gridgraphoptions = [
      { id: 0, 'text': 'Days' },
      { id: 1, 'text': 'Weeks' },
      { id: 2, 'text': 'Months' }
    ];

    //These will be filled in when the page loads
    this.gridgraphoptionsdays = [ { id: 0, text: 'Today' }, { id: 1, text: 'Yesterday' } ];
    this.gridgraphoptionsweeks = [ { id: 0, text: 'This Week' }, { id: 1, text: 'Last Week' } ];
    this.gridgraphoptionsmonths = [ { id: 0, text: 'This Month' }, { id: 1, text: 'Last Month' } ];

    this.dayslimit = 90;
    this.weekslimit = 18;
    this.monthslimit = 6;

    this.intervallabels = {
      '0': {'text': 'Today', 'interval': 'Hour' },
      '1': {'text': 'Yesterday', 'interval': 'Hour' },
      '2': {'text': 'This Week', 'interval': 'Day' },
      '3': {'text': 'Last Week', 'interval': 'Day' },
      '4': {'text': 'This Month', 'interval': 'Day' },
      '5': {'text': 'Last Month', 'interval': 'Day' }
    };

    this.gridfilteroptions = [
      {id: 0, text: 'Top 50 Producers'},
      {id: 1, text: 'Top 100 Producers'},
      {id: 2, text: 'Top 1000 Producers'},
      {id: 3, text: 'Bottom 50 Producers'},
      {id: 4, text: 'Bottom 100 Producers'},
      {id: 5, text: 'Bottom 1000 Producers'},
      {id: 6, text: 'TFN Search'}
    ];

    // Export columns
    this.exportcolumns = [
      {'text': 'Client ID', 'column': 'Client ID'},
      {'text': 'Number Dialed', 'column': 'Number Dialed'},
      {'text': 'Start Int', 'column': 'Start Int'},
      {'text': 'End Int', 'column': 'End Int'},
      {'text': 'Total Calls', 'column': 'Total Calls'},
      {'text': 'Valid Calls', 'column': 'Valid Calls'},
      {'text': 'Risked Calls', 'column': 'Risked Calls'},
      {'text': 'Total Minutes', 'column': 'Total Minutes'},
      {'text': 'Unique ANI', 'column': 'Unique ANI'},
      {'text': 'Revenue Calls', 'column': 'Revenue Calls'},
      {'text': 'XX Second Calls', 'column': 'XX Second Calls'},
      {'text': 'Transport', 'column': 'Transport'},
      {'text': 'Revenue', 'column': 'Revenue'}
    ];

    // grid parameter indices
    this.IDX_WS_COMPANY_ID = 0;
    this.IDX_DATEVALUE = 1;
    this.IDX_FILTERVALUE = 2;
    this.IDX_PAYOUT_TYPE = 3;
    this.IDX_PAYOUT_DESCRIPTION = 4;

    //Options for the day dropdown
    this.graphDaysOptions = [
      { value: 'AllDays',label: 'All Days' },
      { value: 'Sunday',label: 'Sun' },
      { value: 'Monday',label: 'Mon' },
      { value: 'Tuesday',label: 'Tue' },
      { value: 'Wednesday',label: 'Wed' },
      { value: 'Thursday',label: 'Thu' },
      { value: 'Friday',label: 'Fri' },
      { value: 'Saturday',label: 'Sat' },
    ];

    this.state = {
      piechartdatetime: 'today',
      companyID: -1,
      dateRange: 0,
      producerRange: 0,
      payoutType: -1,
      payoutDescription: '',
      piedate: 0,
      gridstatus: '',
      showexportdialog: false,
      showoverlay: false,
      showcompanyoptions: false,
      companyOptions: [],
      statsrows: [],
      decideDropdown: 0,  
      selectedOption: 'AllDays',
      listofdays: 'AllDays',
      griddata: [],
      gridexportall: [],
      time: 0,
      timeunit: 0,
      tbtime: 0,
      tbtimeunit: 0,
      ready: false,
      refreshDate: new Date().toString(),
      tfnValue: '',
      tfn: ''
    };

    this.onClickTitle = this.onClickTitle.bind( this );
    this.onChangeCompanyID = this.onChangeCompanyID.bind( this );
    this.onChangePieDate = this.onChangePieDate.bind( this );
    this.onChangeGridDate = this.onChangeGridDate.bind( this );    
    this.onChangeGridFilter = this.onChangeGridFilter.bind( this );
    this.getCompanyOptions = this.getCompanyOptions.bind( this );
    this.onExport = this.onExport.bind( this );
    this.onExportAll = this.onExportAll.bind( this );
    this.onCloseExportDialog = this.onCloseExportDialog.bind( this );
    this.onCloseExportAllDialog = this.onCloseExportAllDialog.bind( this );
    this.doLogOff = this.doLogOff.bind( this );
    this.onRenderLineCharts = this.onRenderLineCharts.bind( this );
    this.onHandleException = this.onHandleException.bind ( this );
    this.onCalculate = this.onCalculate.bind( this );
    this.onRenderGraphs = this.onRenderGraphs.bind( this );
    this.onChangeGraphTimePeriod = this.onChangeGraphTimePeriod.bind( this );
    this.onChangeGraphTime = this.onChangeGraphTime.bind( this );
    this.onRenderGraphOptions = this.onRenderGraphOptions.bind( this );
    this.onRenderPieChartOptions = this.onRenderPieChartOptions.bind( this );
    this.updateSelectOptions = this.updateSelectOptions.bind( this );
    this.saveExportData = this.saveExportData.bind( this );
    this.onRefreshDashboard = this.onRefreshDashboard.bind( this );
    this.onTFNChanged = this.onTFNChanged.bind( this );
    this.onTFNKeyPress = this.onTFNKeyPress.bind( this );
  }

  //* Component Events *//
  componentDidMount() {

    let counter = 0;
    for ( counter = 2; counter <= this.dayslimit; counter++ ){
      this.gridgraphoptionsdays.push( { 
        id: counter, 
        text: counter.toString() 
      } );
    }

    for ( counter = 2; counter <= this.weekslimit; counter++ ){
      this.gridgraphoptionsweeks.push( { 
        id: counter, 
        text: counter.toString() 
      } );
    }

    for ( counter = 2; counter <= this.monthslimit; counter++ ){
      this.gridgraphoptionsmonths.push( { 
        id: counter, 
        text: counter.toString() 
      } );
    }

    this.getCompanyOptions().then( ( companies ) => {
      let CLIENT_ID = parseInt( this.state.companyID, 10 );
      let PAYOUT_TYPE = parseInt( this.state.payoutType, 10 );
      const DATEVALUE = parseInt( this.state.dateRange, 10 );
      const FILTERVALUE = parseInt( this.state.producerRange, 10 );
      let payoutInfo = this.getPayoutInfoByCompanyID( CLIENT_ID );

      let companyOptions = companies.map( ( company, index ) => {
        company.id = company.Client_ID;
        company.text = company.Client_Name;
        return company;
      } );

      // Set the default clientid to the first on the list.
      if( CLIENT_ID === -1 && companies !== undefined ) {
        if( companies.length > 0 ) {
          CLIENT_ID = parseInt( companies[ 0 ].Client_ID, 10 );
          payoutInfo = this.getPayoutInfoByCompanyID( CLIENT_ID, companyOptions );
          PAYOUT_TYPE = parseInt( payoutInfo.payoutType, 10 );
        }
      }

      let parameters = [
        { WS_COMPANY_ID: CLIENT_ID },
        { DATEVALUE: DATEVALUE },
        { FILTERVALUE: FILTERVALUE },
        { PAYOUT_TYPE: PAYOUT_TYPE }
      ];

      this.getMonthlyStats( CLIENT_ID ).then ( ( statsrows ) => {
        this.setState( {
          showcompanyoptions: false,
          companyOptions: companyOptions,
          companyID: parameters[ this.IDX_WS_COMPANY_ID ].WS_COMPANY_ID,
          dateRange: parameters[ this.IDX_DATEVALUE ].DATEVALUE,
          producerRange: parameters[ this.IDX_FILTERVALUE ].FILTERVALUE,
          payoutType: payoutInfo.type,
          payoutDescription: payoutInfo.description,
          statsrows: statsrows,
          ready: true,
        } );
      } ).catch( ( exception ) => {
        this.setState( { ready: false } );
        this.onHandleException( exception );
      } );

    } ).catch( ( exception ) => {
      this.setState( { ready: false } );
      this.onHandleException( exception );
    } );

  }

  getColumnsByPayoutType() {
    const payoutType = parseInt( this.state.payoutType, 10 );
    let columns = [];
    if( payoutType === 1 ) {
      columns = [
        { 'text': 'Number Dialed', 'column': 'Number Dialed', 'dataType': 2, 'format': 'N0' },
        { 'text': 'Total Calls', 'column': 'Total Calls', 'dataType': 2, 'format': 'N0' },
        { 'text': 'Answered Calls', 'column': 'Answered Calls', 'dataType': 2, 'format': 'N0' },
        { 'text': 'Risked Calls', 'column': 'Risked Calls', 'dataType': 2, 'format': 'N0' },
        { 'text': 'Total Minutes', 'column': 'Total Minutes', 'dataType': 2, 'format': 'N2' },
        { 'text': 'Unique ANI', 'column': 'Unique ANI', 'dataType': 2, 'format': 'N0' },
        { 'text': 'XX Second Calls', 'column': 'XX Second Calls', 'dataType': 2, 'format': 'N0' },
      ];
    } else if( payoutType === 2 ) {
      columns = [
        { 'text': 'Number Dialed', 'column': 'Number Dialed', 'dataType': 2, 'format': 'N0' },
        { 'text': 'Total Calls', 'column': 'Total Calls', 'dataType': 2, 'format': 'N0' },
        { 'text': 'Answered Calls', 'column': 'Answered Calls', 'dataType': 2, 'format': 'N0' },
        { 'text': 'Risked Calls', 'column': 'Risked Calls', 'dataType': 2, 'format': 'N0' },
        { 'text': 'Total Minutes', 'column': 'Total Minutes', 'dataType': 2, 'format': 'N2' },
        { 'text': 'Unique ANI', 'column': 'Unique ANI', 'dataType': 2, 'format': 'N0' },
        { 'text': 'Transport', 'column': 'Transport', 'dataType': 2, 'format': 'C4' },
        { 'text': 'Client Transport', 'column': 'Client Transport', 'dataType': 2, 'format': 'C4' },
        { 'text': 'Revenue Calls', 'column': 'Revenue Calls', 'dataType': 2, 'format': 'N0' },
        { 'text': 'Revenue', 'column': 'Revenue', 'dataType': 2, 'format': 'C2' },
        { 'text': 'Payout', 'column': 'Payout', 'dataType': 2, 'format': 'C2' },
      ];
    } else {
      
      return [];
    }
    return columns;  
  }  

  getCompanyOptions() {
    let api = new EtelAPI( 'wholesale/dashboard/clients' );
    return new Promise( ( resolve, reject ) => {
      api.get( ).then( ( result ) => {
        resolve( result );
      } ).catch( ( error ) =>{
        reject( error );
      } );
    } );
  }

  getCompanyNameByID( companyID ) {
    const companyOptions = this.state.companyOptions;
    if( companyOptions !== undefined ) {
      if( companyOptions.length > 0 ) {
        for( var index = 0;index < companyOptions.length; index++ ){
          const id1 = parseInt( companyOptions[ index ].id, 10 );
          const id2 = parseInt( companyID, 10 );
          if( id1 === id2 ){
            return companyOptions[ index ].text;
          }
        }
      }
    }
    return 'Loading';
  }

  getPayoutInfoByCompanyID( companyID, options ) {
    const companyOptions = options === undefined ? this.state.companyOptions : options;
    if( companyOptions !== undefined ) {
      if( companyOptions.length > 0 ) {
        for( var index = 0;index < companyOptions.length; index++ ){
          const id1 = parseInt( companyOptions[ index ].id, 10 );
          const id2 = parseInt( companyID, 10 );
          if( id1 === id2 ) {
            return { 
              type: parseInt( companyOptions[ index ].Payout_Type, 10 ), 
              description: companyOptions[ index ].Payout_Description 
            };
          }
        }
      }
    }
    return { 
      type: 1, 
      description: ''
    };
  }
  
  hasManyCompanies( ) {
    const companies = this.state.companyOptions;
    if( companies !== undefined ) {
      if( companies.length > 1 ) {
        return true;
      }
    }
    return false;
  }

  getMonthlyStats( clientID ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'wholesale/dashboard' );
      api.uri = '/wholesale/dashboard/' + clientID.toString() + '/metric/monthly/stats';
      api.get().then( ( result ) => {
        resolve( result );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  getMonthlyStatsData( ) {
    const rows = this.state.statsrows;
    if( rows !== undefined ) {
      if( rows.length > 0 ) {
        let monthlystatsrows = rows.map( ( row, index ) => {
          const items = row.METRIC.split( ':' );
          const monthlystat = {
            'label': items[ 0 ],
            'value': items[ 1 ]
          };
          return monthlystat;
        } );
        return monthlystatsrows;
      }
    }
    return [];
  }

  getDateRangeCategory( dateRange ) {
    switch( parseInt( dateRange, 10 ) ) {
    case 0: {
      return 'daily';
    }
    case 1: {
      return 'daily';
    }
    case 2: {
      return 'weekly';
    }
    case 3: {
      return 'weekly';
    }
    case 4: {
      return 'monthly';
    }
    case 5: {
      return 'monthly';
    }
    default:
      return 'daily';
    }
  }

  getProducerLimit( producerRange ) {
    switch( parseInt( producerRange, 10 ) ) {
    case 0: {
      return '50';
    }
    case 1:{
      return '100';
    }
    case 2: {
      return '1000';
    }
    case 3: {
      return '50';
    }
    case 4: {
      return '100';
    }
    case 5: {
      return '1000';
    }
    default:
      return '50';
    }
  }

  getProducerDirection( producerRange ) {
    const range = parseInt( producerRange, 10 );
    if( range >= 0 && range <= 2 ) {
      return 'top';
    } else if( range >= 3 && range <= 5 ) {
      return 'bottom';
    } else {
      return 'top';
    }
  }

  getDatePart( dateRange ) {
    const range = parseInt( dateRange, 10 );
    switch( range ) {
    case 0:{
      return 'today';
    }
    case 1: {
      return 'yesterday';
    }
    case 2:{
      return 'thisweek';
    }
    case 3:{
      return 'lastweek';
    }
    case 4:{
      return 'thismonth';
    }
    case 5: {
      return 'lastmonth';
    }
    default:
      return 'today';
    }
  }

  //** Control Events **//
  onHandleException( e ) {
    const { bugsnag, dispatch } = this.props;
    const alerts = new Alerts( bugsnag,dispatch );
    const status = e.status === undefined ? 0 : e.status;
    if( status === 410 ) {
      alerts.INFO( 'Client Dashboard', 'Your session has expired.' , 5000 );
      this.doLogOff();
    } else if( status === 500 ) {
      alerts.INFO( 'Client Dashboard', e.statusText , 5000 );
      this.doLogOff();
    } else {
      alerts.CRITICAL( 'Client Dashboard', e );
    }
  }

  doLogOff( ) {
    const { dispatch } = this.props;
    const auth = this.props.auth;
    const history = this.props.history;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  onRefreshDashboard( ) {
    this.setState( {
      refreshDate: new Date().toString()
    } );
  }

  onTFNChanged( e ) {
    this.setState( { 
      tfnValue: e.target.value
    } );
  }

  onTFNKeyPress( key ) {
    const tfnValue = this.state.tfnValue;
    const { bugsnag, dispatch } = this.props;
    const alert = new Alerts( bugsnag, dispatch );
    if( key === 'Enter' ) {
      if( tfnValue !== undefined && tfnValue !== null && tfnValue !== '' ) {
        if( tfnValue.length === 10 ) {
          this.setState( { 
            tfn: tfnValue
          } );
        } else {
          alert.WARNING('TFN Search', 'The TFN must be 10 digits (e.g., 8001112222)', 5000 );
        }
      } else {
        alert.WARNING('TFN Search', 'The TFN must be 10 digits (e.g., 8001112222)', 5000 );
      }
    }
  }

  onClickTitle( e ) {
    this.setState( {
      showcompanyoptions: true
    } );
  }

  onChangeCompanyID( e ) {

    try {

      const CLIENT_ID = e.target.value;
      const DATEVALUE = this.state.dateRange;
      const FILTERVALUE = this.state.producerRange;
      const payoutInfo = this.getPayoutInfoByCompanyID( CLIENT_ID );

      let parameters = [
        { WS_COMPANY_ID: CLIENT_ID },
        { DATEVALUE: DATEVALUE },
        { FILTERVALUE: FILTERVALUE },
        { PAYOUT_TYPE: payoutInfo.type }
      ];

      this.getMonthlyStats( CLIENT_ID ).then ( ( statsrows ) => {
        this.setState( {
          showcompanyoptions: false,
          companyID: parameters[ this.IDX_WS_COMPANY_ID ].WS_COMPANY_ID,
          payoutType: payoutInfo.type,
          payoutDescription: payoutInfo.description,
          dateRange: parameters[ this.IDX_DATEVALUE ].DATEVALUE,
          producerRange: parameters[ this.IDX_FILTERVALUE ].FILTERVALUE,
          statsrows: statsrows,
        } );
      } ).catch( ( exception )=>{
        this.onHandleException( exception );
      } );

    } catch ( exception ) {
      this.onHandleException( exception );
    }

  }

  onChangePieDate( e ) {
    const CLIENT_ID = this.state.companyID;
    const DATEVALUE = e.target.value;
    const FILTERVALUE = this.state.producerRange;

    try {

      const payoutInfo = this.getPayoutInfoByCompanyID( CLIENT_ID );

      let parameters = [
        { WS_COMPANY_ID: parseInt( CLIENT_ID, 10 ) },
        { DATEVALUE: parseInt( DATEVALUE, 10 ) },
        { FILTERVALUE: parseInt( FILTERVALUE, 10 ) },
        { PAYOUT_TYPE: parseInt( payoutInfo.payoutType, 10 ) },
      ];

      this.getMonthlyStats( CLIENT_ID ).then( ( statsrows ) => {
        this.setState( {
          showcompanyoptions: false,
          piedate: parameters[ this.IDX_DATEVALUE ].DATEVALUE,
          statsrows: statsrows,
          ready: true,
        } );
      } ).catch ( ( exception ) => {
        this.onHandleException( exception );
      } );

    } catch ( exception ) {
      this.onHandleException( exception );
    }
  }

  onChangeGraphTime( e ) {
    let time = parseInt( e.target.value, 10 );
    this.setState( { 
      decideDropdown: time,
      tbtimeunit: 0,
      tbtime: time,
      selectedOption: 'AllDays'
    } );
  }

  onChangeGraphTimePeriod( e ) {
    const daysBack = parseInt( e.target.value, 10 );
    let selectedOption = 'AllDays';
    
    if( daysBack > 1 ){
      selectedOption = this.state.selectedOption;
    }
    
    this.setState( { 
      tbtimeunit: daysBack, 
      selectedOption: selectedOption
    } );
  }

  onChangeGridFilter( e ) {
    this.setState( {
      producerRange: parseInt( e.target.value, 10 ),
      tfnValue: '',
      tfn: ''
    } );
  }

  onChangeGridDate( e ) {
    const value = e.target.value;
    this.setState( { 
      dateRange: value,
    } );
  }
 
  onCalculate( e ) {
    if( e.charttype === 'gauge' ) {
      if( e.title === 'Percentage of Risked Calls' ) {
        this.calculatePercentageOfRiskedCalls( e );
      }
    }
  }

  calculatePercentageOfRiskedCalls( e ) {
    let total = 0;
    let risked = 0;
    let percentage = 0;
    if( e.data !== undefined ) {
      if( e.data.length > 0 ) {
        for( let index = 0; index < e.data.length; index++ ){
          const row = e.data[ index ];
          total += parseInt( row['Total'], 10 );
          if( row['Category'] === 'Risked Calls' ) {
            risked = parseInt( row['Total'], 10 );
          }
        }
        percentage = parseInt( ( ( risked * 100 ) / total ), 10 );
        e.data.unshift( { 'Category': e.value, 'Total': percentage } );
      }
    }
  }

  onExport( e ) {
    const { bugsnag, dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const dateRangeCategory = this.getDateRangeCategory( this.state.dateRange );
    let api = new EtelAPI ( 'wholesale/dashboard' );
    api.uri += '/' + this.state.companyID.toString() + '/metric/callstats/' + dateRangeCategory;
    const limit = this.getProducerLimit( this.state.producerRange );
    const direction = this.getProducerDirection( this.state.producerRange );
    const datepart = this.getDatePart( this.state.dateRange );
    let parameters = [
      { limit: limit },
      { direction: direction },
      { datepart: datepart }
    ];
    alerts.INFO('Wholesale Dashboard Export', 'Please wait while exporting data....', 2500 );
    api.get( parameters ).then( ( exportdata ) => {
      if( exportdata !== undefined ) {
        if( exportdata.length > 0 ) {
          this.exportData( this.getColumnsByPayoutType(), exportdata )
        } else {
          alerts.INFO( 'Wholesale Dashboard', 'No data to export.', 2500 );
        }
      } else {
        alerts.INFO( 'Wholesale Dashboard', 'No data to export.', 2500 );
      }
  
    } ).catch( ( exception )=> {
      this.onHandleException( exception );
    } );
  }

  onExportAll( e ) {
    const { bugsnag, dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const dateRangeCategory = this.getDateRangeCategory( this.state.dateRange );
    let api = new EtelAPI ( 'wholesale/dashboard' );
    api.uri += '/' + this.state.companyID.toString() + '/metric/callstats/' + dateRangeCategory;
    const limit = 'all';
    const datepart = this.getDatePart( this.state.dateRange );
    let parameters = [
      { limit: limit },
      { datepart: datepart }
    ];
    alerts.INFO('Wholesale Dashboard Export', 'Please wait while exporting data....', 5000 );
    api.get( parameters ).then( ( exportdata ) => {
      if( exportdata !== undefined ) {
        if( exportdata.length > 0 ) {
          this.exportData( this.getColumnsByPayoutType(), exportdata )
        } else {
          alerts.INFO( 'Wholesale Dashboard', 'No data to export.', 2500 );  
        }
      } else {
        alerts.INFO( 'Wholesale Dashboard', 'No data to export.', 2500 );
      }

    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );
  }

  exportData( headers, data ) {
    const { bugsnag, dispatch } = this.props;
    const alert = new Alerts( bugsnag, dispatch );
    
    let exportSource = data.map( ( item, index ) => {
      let exportItem = {};
      for( let headerIndex = 0; headerIndex < headers.length; headerIndex++ ) {
        const header = headers[ headerIndex ];
        const value = item[ header.column ];
        exportItem[ header.text ] = ( value !== null && value !== undefined ) ? value : '';
      }
      return exportItem;
    } );

    let excelFilename = 'Wholesale_Dashboard.xlsx';

    //Create placeholder element to host the grid
    let pHolder = document.createElement( 'div' );
    let exportGrid = new wjcGrid.FlexGrid( pHolder,{ itemsSource: exportSource } );

    //Export the contents to an excel file
    wjcGridXlsx.FlexGridXlsxConverter.saveAsync( exportGrid, { 'includeColumnHeaders': true }, excelFilename, () => {
      const title = 'Exported ' + this.state.caption;
      const message = 'Successfully exported to "' + excelFilename + '".';
      alert.SUCCESS( title, message, 2500 );
    } );    
  }

  saveExportData( data ) {
    this.setState( { 
      griddata: data 
    } );
  }

  onCloseExportDialog( e ) {
    this.setState( {
      showexportdialog: false,
    } );
  }

  onCloseExportAllDialog( e ) {
    this.setState( {
      showexportalldialog: false,
    } );
  }

  //* Render Functions *//
  onRenderHeader( ) {
    if( this.state.showcompanyoptions === true ) {
      return (
        <div className="wholesale-dashboard-header">
          <EditSectionDropdown value={this.state.companyID} onChanged={this.onChangeCompanyID} options={this.state.companyOptions}/>
        </div>
      );
    } else {

      let companyID = this.state.companyID;
      const companyName = this.getCompanyNameByID( companyID );
      const title = companyName === 'Loading' ? companyName + ' Stats...' : companyName + ' Stats';
      if( this.hasManyCompanies() === true ) {
        return (
          <div className="wholesale-dashboard-header">
            <span data-tip={this.state.payoutDescription} 
              data-for='wholesale-dashboard-company-link-tooltip'
              className="wholesale-dashboard-company-link" 
              onClick={this.onClickTitle}>
              {title}
            </span>
            <ReactToolTip 
              id="wholesale-dashboard-company-link-tooltip" 
              offset={{ bottom: 10}} 
              type="info" 
              place="bottom"
              effect='solid' 
            />
          </div>
        );

      } else {
        return (
          <div className="wholesale-dashboard-header">
            <span 
              data-tip={this.state.payoutDescription} 
              data-for='wholesale-dashboard-company-title-tooltip' 
              className="wholesale-dashboard-company-title">
              {title}
            </span>
            <ReactToolTip 
              id="wholesale-dashboard-company-title-tooltip" 
              offset={{ bottom: 10}} 
              type="info" 
              place="bottom"
              effect='solid' 
            />
          </div>
        );
      }
    }
  }

  onRenderGraphs( ) {
    this.setState( { 
      time: this.state.tbtime, 
      timeunit: this.state.tbtimeunit, 
      listofdays: this.state.selectedOption === '' ? 'AllDays' : this.state.selectedOption
    } );
  }

  updateSelectOptions( selectedValue ) {
    let newstring = selectedValue.split( ',' );
    if ( newstring.length > 1 ) {

      //If the option "AllDays" is the first item in the list and there is more than one item, remove it
      if ( newstring[0] === 'AllDays' ) {
        newstring.shift( newstring[0] );
        selectedValue = newstring.join( ',' );
      }

      //If the option "AllDays" is the last item in the list and there is more than one item, exclude all other items
      if ( newstring[newstring.length - 1] === 'AllDays' ) {
        selectedValue = newstring[newstring.length - 1];
      }
    } else {
      if( selectedValue === '' ) {
        selectedValue = 'AllDays';
      }
    }

    this.setState( { 
      selectedOption: selectedValue 
    } );
  }
 
  onRenderGraphOptions() {
    let label = '';
    let timeoptions = null;
    let decideDropdown = this.state.decideDropdown;
    let multidropdown = '';
    let multidropdownLabel = '';
    if ( decideDropdown === 0 ) {
      label = 'Days Back';
      timeoptions = this.gridgraphoptionsdays;
      if ( this.state.tbtimeunit >= 2 ) {
        multidropdownLabel = ( 
          <label className="wholesale-dashboard-filter-2-label">
            {'On Days'}
          </label> 
        );
        multidropdown = (
          <Select placeholder={'Select Day(s)'} 
            value={this.state.selectedOption} 
            options={this.graphDaysOptions} 
            multi={true} 
            clearable={false} 
            scrollMenuIntoView={true} 
            simpleValue={true}
            onChange={this.updateSelectOptions} />
        );
      }
    } else if ( decideDropdown === 1 ) {
      label = 'Weeks Back';
      timeoptions = this.gridgraphoptionsweeks;
 
    } else if ( decideDropdown === 2 ) {
      label = 'Months Back';
      timeoptions = this.gridgraphoptionsmonths;
    }
    return (
      <div className="wholesale-dashboard-filter-2">
        <label className="wholesale-dashboard-filter-2-label">
          {'Time'}
        </label>            
        <EditSectionDropdown value={this.state.tbtime} options={this.gridgraphoptions} onChanged={this.onChangeGraphTime} />
        <label className="wholesale-dashboard-filter-2-label">
          {label}
        </label>              
        <EditSectionDropdown value={this.state.tbtimeunit} options={timeoptions} onChanged={this.onChangeGraphTimePeriod} />
        {multidropdownLabel}
        {multidropdown}
      </div>      
    );
  }

  onRenderPieChartOptions() {
    return (
      <div className="wholesale-dashboard-filter-1">
        <span className="wholesale-dashboard-filter-1-label">
          {'Show Data From'}
        </span>
        <EditSectionDropdown value={this.state.piedate} onChanged={this.onChangePieDate} options={this.griddateoptions} />
      </div>    
    );
  }  

  onRenderPieCharts( ) {
    const companyID = this.state.companyID;
    const datevalue = this.griddateoptions[ this.state.piedate ].value;
    return (
      <div className="wholesale-dashboard-pie-charts"> 
        <div className="wholesale-dashboard-pie-charts-item">
          <LoadableDashboardPieChart
            endpoint={'/wholesale/dashboard/' + companyID + '/' + datevalue + '/metric/callsbynpa'}
            bindingLabel={'Category'}
            bindingValue={'Total'}
            title={'Calls By NPA'}
            companyID={companyID}
            datePart={datevalue} 
            palette={['#000000', '#2196F3','#8BC34A','#FF5722','#795548','#9C27B0','#607D8B','#FFC107','#009688','#3F51B5']}
            refreshDate={this.state.refreshDate}
          />
        </div>
        <div className="wholesale-dashboard-pie-charts-item">
          <LoadableDashboardPieChart
            endpoint={'/wholesale/dashboard/' + companyID + '/' + datevalue + '/metric/riskedtotals'}
            bindingLabel={'Category'}
            bindingValue={'Total'}
            title={'Risked vs Non-Risked Calls'}
            companyID={companyID}
            datePart={datevalue} 
            palette={['#607D8B','#009688','#FF5722','#795548','#9C27B0','#FFC107','#3F51B5','#000000', '#2196F3','#8BC34A']}
            refreshDate={this.state.refreshDate}
          />
        </div>
        <div className="wholesale-dashboard-pie-charts-item">
          <LoadableDashboardPieChart
            endpoint={'/wholesale/dashboard/' + companyID + '/' + datevalue + '/metric/landandcelltotals'}
            bindingLabel={'Category'}
            bindingValue={'Total'}
            title={'Land vs Cell Calls'}
            companyID={companyID}
            datePart={datevalue} 
            palette={['#8BC34A','#3F51B5','#FF5722','#795548','#9C27B0','#607D8B','#FFC107','#009688','#000000', '#2196F3']}
            refreshDate={this.state.refreshDate}
          />
        </div>
        <div className="wholesale-dashboard-pie-charts-item">
          <LoadableDashboardGaugeChart
            charttype='gauge'
            title={'Percentage of Risked Calls'}
            value={'percent'}
            endpoint={'/wholesale/dashboard/'+ companyID + '/' + datevalue + '/metric/riskedtotals'}
            refreshDate={this.state.refreshDate}
          />
        </div>
        <div className="wholesale-dashboard-pie-charts-item">
          <MonthlyStatsTile 
            title="Monthly Stats" 
            clientID={this.state.companyID}
            refreshDate={this.state.refreshDate} 
          />
        </div>          
      </div>
    );
  }

  onRenderLineCharts( ) {
    const companyID = this.state.companyID;
    const interval = this.state.tbtime;
    const intervalNumber = this.state.tbtimeunit;
    let xlabel = 'Interval';

    // Determine Labels for Days
    if ( interval === 0 ) {
      if ( intervalNumber < 2 ) {
        xlabel = 'Hour';
      } else {
        xlabel = 'Day';
      }
    }

    // Determine Labels for Weeks
    if ( interval === 1 ) {
      if ( intervalNumber < 2 ) {
        xlabel = 'Day';
      } else {
        xlabel = 'Week';
      }
    }

    //Determine Labels for Months
    if ( interval === 2 ) {
      if ( intervalNumber < 2 ){
        xlabel = 'Day';
      } else {
        xlabel = 'Month';
      }
    }

    let parameters = [
      { TimeUnitAmount: parseInt( this.state.tbtimeunit, 10 ) },
      { ListOfDays: this.state.selectedOption }
    ];

    let riskedendpoint = '/wholesale/dashboard/' + companyID.toString() + '/risk/chart/answeredcalls';
    let revenueendpoint = '/wholesale/dashboard/' + companyID.toString() + '/revenue/chart/calls';

    const timeUnit = parseInt( this.state.tbtime, 10 );
    if( timeUnit === 0 /* Days */ ) {
      riskedendpoint += '/days';
      revenueendpoint += '/days';
    } else if( timeUnit === 1 /* Weeks */ ) {
      riskedendpoint += '/weeks';
      revenueendpoint += '/weeks';
    } else if( timeUnit === 2 /* Months */ ) {
      riskedendpoint += '/months';
      revenueendpoint += '/months';
    } else {
      riskedendpoint += '/days';
      revenueendpoint += '/days';
    }

    // Second line graph title
    let revenueLineGraphTitle = 'Revenue Calls';
    if( this.state.payoutType === 1 ){
      revenueLineGraphTitle = 'XX Second Calls';
    }

    return (
      <div className="wholesale-dashboard-line-charts">
        <div className="wholesale-dashboard-line-charts-item">
          <LoadableDashboardGraph
            endpoint={riskedendpoint}
            parameters={parameters}
            chartType={1}
            columnLayout={[{'binding':'Risked Calls','name':'Risked Calls'},{'binding':'Answered Calls','name':'Answered Calls'}]}
            title={'Answered Calls/Risked Calls'}
            xlabel={xlabel}
            xaxis={'PERIOD_LABEL'}
            palette={['#795548','#3F51B5','#FFC107','#009688','#000000', '#2196F3','#8BC34A','#FF5722','#9C27B0','#607D8B']}
            client_id={companyID}
            daysBack={this.state.tbtimeunit}
            refreshDate={this.state.refreshDate}
          />
        </div>
        <div className="wholesale-dashboard-line-charts-item">
          <LoadableDashboardGraph
            endpoint={revenueendpoint}
            parameters={parameters}
            chartType={3}
            columnLayout={[{'binding':'Revenue Calls','name':revenueLineGraphTitle}]}
            title={revenueLineGraphTitle}
            xlabel={xlabel}
            xaxis={'PERIOD_LABEL'}
            palette={['#009688','#795548','#3F51B5','#FFC107','#000000', '#2196F3','#8BC34A','#FF5722','#9C27B0','#607D8B']}
            client_id={companyID}
            daysBack={this.state.tbtimeunit}
            refreshDate={this.state.refreshDate}
          />
        </div>
      </div>
    );
  }

  onRenderGridFilters( ) {
    let exportalltooltiptext = 'Export all data for ';
    const gridRange = this.state.dateRange === undefined ? 0 : parseInt( this.state.dateRange, 10 );
    exportalltooltiptext += this.griddateoptions[ gridRange ].text.toLowerCase() + '.';
    if( this.state.producerRange === 6 ) {
      return (
        <div className="wholesale-dashboard-filter-3">
          <label className="wholesale-dashboard-filter-3-label">
            {'Show The'}
          </label>
          <EditSectionDropdown value={this.state.producerRange} onChanged={this.onChangeGridFilter} options={this.gridfilteroptions} />
          <label className="wholesale-dashboard-filter-3-label">
            {'TFN'}
          </label>
          <EditSectionInput value={this.state.tfnValue} onChanged={this.onTFNChanged} onKeyPress={this.onTFNKeyPress} />
          <div className="wholesale-dashboard-filter-3-export">
            <ListExport onExport={this.onExport} data={this.state.griddata} visible={true} tooltiptext={'Export data from grid.'} />
          </div>
        </div>
      );
    } else {
      return (
        <div className="wholesale-dashboard-filter-3">
          <label className="wholesale-dashboard-filter-3-label">
            {'Show The'}
          </label>
          <EditSectionDropdown value={this.state.producerRange} onChanged={this.onChangeGridFilter} options={this.gridfilteroptions} />
          <label className="wholesale-dashboard-filter-3-label">
            {'From '}
          </label>
          <EditSectionDropdown value={this.state.dateRange} onChanged={this.onChangeGridDate} options={this.griddateoptions} />
          <div className="wholesale-dashboard-filter-3-export">
            <ListExport onExport={this.onExport} data={this.state.griddata} visible={true} tooltiptext={'Export data from grid.'} />
            <ListExport onExport={this.onExportAll} data={this.state.gridexportall} visible={true} caption="Export All" width="150px" tooltiptext={exportalltooltiptext} />
          </div>
        </div>
      );
    }
  }

  onRenderGrid() {
    const dateRangeValue = this.griddateoptions[ this.state.dateRange ];
    return (
      <div className="wholesale-dashboard-grid">
        <div className="wholesale-dashboard-grid-item">
          <LoadableDashboardGrid
            companyID={this.state.companyID}
            dateRange={dateRangeValue}
            producerRange={this.state.producerRange}
            payoutType={this.state.payoutType}
            onLoad={this.saveExportData}
            refreshDate={this.state.refreshDate}
            tfn={this.state.tfn}
          />      
        </div>
      </div>
    );
  }

  render( ) {
    const showexportdialog = this.state.showexportdialog;
    const showexportalldialog = this.state.showexportalldialog;
    const ready = this.state.ready;
    let exportcolumns = this.exportcolumns;
    if( ready === true ) {
      return (
        <PageAuthorize groups={['Administrators','Operations','Management','Wholesale','Wholesale Client']}>
          <RefreshTimer refreshRate={900000} onTick={this.onRefreshDashboard} />
          <div className="wholesale-dashboard">
            {this.onRenderHeader()}
            {this.onRenderPieChartOptions()}            
            {this.onRenderPieCharts()}
            {this.onRenderGraphOptions()}
            {this.onRenderLineCharts()}
            {this.onRenderGridFilters()}            
            {this.onRenderGrid()}
            <ListExportDialog show={showexportdialog} width={20} height={30} onClose={this.onCloseExportDialog} data={this.state.griddata} from="Wholesale Dashboard" headers={exportcolumns} />
            <ListExportDialog show={showexportalldialog} width={20} height={30} onClose={this.onCloseExportAllDialog} data={this.state.gridexportall} from="Wholesale Dashboard" headers={exportcolumns} />
            <Overlay show={showexportdialog} />
          </div>
        </PageAuthorize>
      );
    } else {
      return (
        <PageAuthorize groups={['Administrators','Operations','Management','Wholesale','Wholesale Client']}>
          <div className="wholesale-dashboard-loading">
            {'Loading Dashboard...'}
          </div>
        </PageAuthorize>
      );
    }
  }
}

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( WholesaleDashboard ) );



// WEBPACK FOOTER //
// ./src/content/wholesale/dashboard/components/WholesaleDashboard.js